<template>
  <div>
    <div class="parent">
      <v-card>
        <v-card-title class="info-title" @click="$emit('clicked', index)">
          <div class="text-center text-padding">
            {{ item.StrState }}
          </div>
        </v-card-title>
        <app-row
          icon="question-circle"
          title="نوع تحصیل:"
          :value="item.Hozoori"
        />

        <app-row icon="hashtag" title="شناسه درخواست:" :value="item.Fserial" />
        <app-row
          icon="calendar-alt"
          title="تاریخ درخواست:"
          :value="item.DDate"
        />
        <app-row
          icon="calendar-alt"
          title="تاریخ شروع:"
          :value="item.D_Start"
        />
        <app-row icon="map-marked-alt" title="استان:" :value="item.OstanName" />
        <app-row icon="city" title="شهر:" :value="item.ShahrestanName" />
        <app-row icon="building" title="نام موسسه:" :value="item.N_Location" />
        <app-row icon="book" title="رشته:" :value="item.N_Field" />
        <div style="padding: 15px">
          <v-row align="center">
            <v-col class="d-flex">
              <b>توضیحات طلبه:</b>
            </v-col>
          </v-row>
          <v-row align="center">
            <v-col class="content">
              <span v-html="item.StudentComment"></span>
            </v-col>
          </v-row>

          <v-row align="center">
            <v-col class="d-flex">
              <b>نظر آموزش:</b>
            </v-col>
          </v-row>
          <v-row align="center">
            <v-col class="content">
              {{ item.AmoozeshState }}.
              <span v-html="item.AmoozeshComment"></span>
            </v-col>
          </v-row>
          <v-row align="center">
            <v-col class="d-flex">
              <b>نظر حراست:</b>
            </v-col>
          </v-row>
          <v-row align="center">
            <v-col class="content">
              {{ item.TahghighatState }}.
              <span v-html="item.TahghighatComment"></span>
            </v-col>
          </v-row>

          <v-row v-if="item.Removeable" class="ltr">
            <v-btn
              color="red white--text"
              class="register"
              rounded
              @click="$emit('removeRequest', item.Fserial)"
            >
              حذف درخواست
            </v-btn>
          </v-row>
          <div style="padding: 5px"></div>
        </div>
      </v-card>
    </div>
  </div>
</template>

<script>
import DetailRow from "@/components/DetailRow";
export default {
  props: ["item", "index", "selectedItem"],
  computed: {
    selected() {
      return this.selectedItem == this.index;
    },
    dateRange() {
      return "از " + this.item.AzTarikh + " تا " + this.item.TaTarikh;
    },
  },
  components: {
    appRow: DetailRow,
  },
};
</script>
<style scoped>
.register {
  margin: 20px 20px 0 20px !important;
}
</style>
